export type FieldXpr = { $type: "field"; name: string };

export const fieldExpr = (field: string): FieldXpr => ({
  $type: "field",
  name: field,
});
